import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ConfirmSvg } from "../../../assets/images/confirm.svg";
import { Theme } from "../../core/Models/CustomSiteConfigModel";
import { themeService } from "../../core/NotificationStripNav/ThemeService";

const ContactUsSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [theme, setTheme] = useState<Theme | null>(themeService.getTheme());

  useEffect(() => {
    const unsubscribe = themeService.subscribe(setTheme);
    return () => unsubscribe();
  }, []);

  return (
    <div className="cuntact-us-success">
      <div className="success-image">
        <ConfirmSvg
          fill={theme?.textColor}
          className="confirm-img"
        ></ConfirmSvg>
      </div>
      <div className="succcess-message">
        Success! Your query has been sent to our support team. Someone will be
        in touch shortly.
      </div>
      <div
        className="succcess-action"
        onClick={() => {
          navigate(`/`);
        }}
      >
        Go home
      </div>
    </div>
  );
};

export default ContactUsSuccess;
